// // components/signin.jsx
// import React, { useState, useContext } from 'react';
// import { UserContext } from './userContext';
// import { useNavigate } from 'react-router-dom';
// import { backendUrl } from "./config";
// import { Paper, Typography, TextField, Button } from '@mui/material';
// import { makeStyles } from '@mui/styles';

// const useStyles = makeStyles(() => ({
//     formContainer: {
//         padding: 32,
//         maxWidth: 400,
//         margin: 'auto',
//         backgroundColor: '#fff',
//         boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
//         borderRadius: 8,
//     },
//     formField: {
//         marginBottom: '3px !important',
//         width: '100%',
//     },
//     submitButton: {
//         marginTop: 16,
//         width: '100%',
//         backgroundColor: '#4b9ef1 !important',
//         color: '#fff !important',
//     },
// }));

// const Signin = () => {
//     const classes = useStyles();
//     const [username, setUsername] = useState("");
//     const [password, setPassword] = useState("");
//     const [message, setMessage] = useState("");
//     const { updateUser } = useContext(UserContext);
//     const navigate = useNavigate();

//     const handleSignin = async (e) => {
//         e.preventDefault();
//         try {
//             const response = await fetch(`${backendUrl}/signin`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: "include", // ✅ So cookie is sent
//                 body: JSON.stringify({ username, password }),
//             });
//             const data = await response.json();

//             if (!response.ok) {
//                 setMessage(data.message || "Signin failed.");
//             } else {
//                 updateUser(data.user); // ✅ sets localStorage
//                 navigate("/dashboard");
//             }
//         } catch (error) {
//             setMessage("Error during signin: " + error.message);
//         }
//     };

//     return (
//         <Paper className={classes.formContainer}>
//             <Typography variant="h5" align="center" gutterBottom>Sign In</Typography>
//             <form onSubmit={handleSignin}>
//                 <TextField label="Username" variant="outlined" className={classes.formField} value={username} onChange={(e) => setUsername(e.target.value)} required />
//                 <TextField label="Password" variant="outlined" type="password" className={classes.formField} value={password} onChange={(e) => setPassword(e.target.value)} required />
//                 <Button type="submit" variant="contained" className={classes.submitButton}>Sign In</Button>
//             </form>
//             {message && (
//                 <Typography variant="body2" align="center" style={{ marginTop: 16, fontSize: '0.85rem' }}>
//                     {message}
//                 </Typography>
//             )}
//         </Paper>
//     );
// };

// export default Signin;





















// // components/signin.jsx
// import React, { useState, useContext } from 'react';
// import { UserContext } from './userContext';
// import { useNavigate, Link } from 'react-router-dom';
// import { backendUrl } from "./config";
// import { Paper, Typography, TextField, Button, Divider } from '@mui/material';
// import { makeStyles } from '@mui/styles';

// const useStyles = makeStyles(() => ({
//     formContainer: {
//         padding: 32,
//         maxWidth: 400,
//         margin: 'auto',
//         backgroundColor: '#fff',
//         boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
//         borderRadius: 8,
//     },
//     formField: {
//         marginBottom: '16px !important',
//         width: '100%',
//     },
//     submitButton: {
//         marginTop: 16,
//         width: '100%',
//         backgroundColor: '#4b9ef1 !important',
//         color: '#fff !important',
//     },
//     googleButton: {
//         marginTop: 16,
//         width: '100%',
//         backgroundColor: '#db4437 !important',
//         color: '#fff !important',
//     },
//     footer: {
//         marginTop: 16,
//         display: 'flex',
//         justifyContent: 'space-between',
//     },
// }));

// const Signin = () => {
//     const classes = useStyles();
//     const [username, setUsername] = useState("");
//     const [password, setPassword] = useState("");
//     const [message, setMessage] = useState("");
//     const { updateUser } = useContext(UserContext);
//     const navigate = useNavigate();

//     const handleSignin = async (e) => {
//         e.preventDefault();
//         try {
//             const response = await fetch(`${backendUrl}/signin`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: "include",
//                 body: JSON.stringify({ username, password }),
//             });
//             const data = await response.json();

//             if (!response.ok) {
//                 setMessage(data.message || "Signin failed.");
//             } else {
//                 updateUser(data.user); // update user context/localStorage as needed
//                 navigate("/dashboard");
//             }
//         } catch (error) {
//             setMessage("Error during signin: " + error.message);
//         }
//     };

//     const handleGoogleSignin = () => {
//         // Redirect user to your backend's Google OAuth endpoint.
//         window.location.href = `${backendUrl}/auth/google`;
//     };

//     return (
//         <Paper className={classes.formContainer}>
//             <Typography variant="h5" align="center" gutterBottom>
//                 Sign In
//             </Typography>
//             <form onSubmit={handleSignin}>
//                 <TextField
//                     label="Username"
//                     variant="outlined"
//                     className={classes.formField}
//                     value={username}
//                     onChange={(e) => setUsername(e.target.value)}
//                     required
//                 />
//                 <TextField
//                     label="Password"
//                     variant="outlined"
//                     type="password"
//                     className={classes.formField}
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     required
//                 />
//                 <Button type="submit" variant="contained" className={classes.submitButton}>
//                     Sign In
//                 </Button>
//             </form>

//             {/* Divider to visually separate options */}
//             <Divider style={{ margin: "24px 0" }} />

//             {/* Google Sign In */}
//             <Button
//                 onClick={handleGoogleSignin}
//                 variant="contained"
//                 className={classes.googleButton}
//             >
//                 Sign In with Google
//             </Button>

//             <div className={classes.footer}>
//                 {/* Link to Forgot Password */}
//                 <Typography variant="body2">
//                     <Link to="/forgot-password" style={{ textDecoration: 'none' }}>
//                         Forgot Password?
//                     </Link>
//                 </Typography>
//             </div>

//             {message && (
//                 <Typography
//                     variant="body2"
//                     align="center"
//                     style={{ marginTop: 16, fontSize: '0.85rem' }}
//                 >
//                     {message}
//                 </Typography>
//             )}
//         </Paper>
//     );
// };

// export default Signin;















// import React, { useState, useContext } from 'react';
// import { backendUrl } from "./config";
// import { UserContext } from './userContext';
// import { useNavigate, Link } from 'react-router-dom';
// import { Paper, Typography, TextField, Button, Divider } from '@mui/material';
// import { makeStyles } from '@mui/styles';

// const useStyles = makeStyles(() => ({
//     formContainer: {
//         padding: 32,
//         maxWidth: 400,
//         margin: 'auto',
//         backgroundColor: '#fff',
//         boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
//         borderRadius: 8,
//     },
//     formField: {
//         marginBottom: '16px !important',
//         width: '100%',
//     },
//     submitButton: {
//         marginTop: 16,
//         width: '100%',
//         backgroundColor: '#4b9ef1 !important',
//         color: '#fff !important',
//     },
//     googleButton: {
//         marginTop: 16,
//         width: '100%',
//         backgroundColor: '#db4437 !important',
//         color: '#fff !important',
//     },
//     footer: {
//         marginTop: 16,
//         display: 'flex',
//         justifyContent: 'space-between',
//     },
// }));

// const Signin = () => {
//     const classes = useStyles();
//     const [username, setUsername] = useState("");
//     const [password, setPassword] = useState("");
//     const [message, setMessage] = useState("");
//     const { updateUser } = useContext(UserContext);
//     const navigate = useNavigate();

//     const handleSignin = async (e) => {
//         e.preventDefault();
//         try {
//             // 1) Sign in via POST to same-origin
//             const response = await fetch(`${backendUrl}/signin`, {
//                 method: 'POST',
//                 credentials: 'include',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ username, password }),
//             });
//             const data = await response.json();

//             if (!response.ok) {
//                 setMessage(data.message || 'Signin failed.');
//                 return;
//             }

//             // 2) Fetch dashboard to establish session
//             const userId = data.user.id || data.user._id;
//             await fetch(`${backendUrl}/dashboard/${userId}`, { credentials: 'include' });

//             // 3) Update context and navigate
//             updateUser(data.user);
//             navigate('/dashboard');
//         } catch (error) {
//             setMessage('Error during signin: ' + error.message);
//         }
//     };

//     const handleGoogleSignin = () => {
//         // Redirect to same-origin OAuth endpoint
//         window.location.href = '/auth/google';
//     };

//     return (
//         <Paper className={classes.formContainer}>
//             <Typography variant="h5" align="center" gutterBottom>
//                 Sign In
//             </Typography>
//             <form onSubmit={handleSignin}>
//                 <TextField
//                     label="Username"
//                     variant="outlined"
//                     className={classes.formField}
//                     value={username}
//                     onChange={(e) => setUsername(e.target.value)}
//                     required
//                 />
//                 <TextField
//                     label="Password"
//                     variant="outlined"
//                     type="password"
//                     className={classes.formField}
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     required
//                 />
//                 <Button type="submit" variant="contained" className={classes.submitButton}>
//                     Sign In
//                 </Button>
//             </form>

//             <Divider style={{ margin: '24px 0' }} />

//             <Button
//                 onClick={handleGoogleSignin}
//                 variant="contained"
//                 className={classes.googleButton}
//             >
//                 Sign In with Google
//             </Button>

//             <div className={classes.footer}>
//                 <Typography variant="body2">
//                     <Link to="/forgot-password" style={{ textDecoration: 'none' }}>
//                         Forgot Password?
//                     </Link>
//                 </Typography>
//             </div>

//             {message && (
//                 <Typography
//                     variant="body2"
//                     align="center"
//                     style={{ marginTop: 16, fontSize: '0.85rem' }}
//                 >
//                     {message}
//                 </Typography>
//             )}
//         </Paper>
//     );
// };

// export default Signin;









// restore web
// // components/signin.jsx
// import React, { useState, useContext } from 'react';
// import { UserContext } from './userContext';
// import { useNavigate } from 'react-router-dom';
// import { backendUrl } from "./config";
// import { Paper, Typography, TextField, Button } from '@mui/material';
// import { makeStyles } from '@mui/styles';

// const useStyles = makeStyles(() => ({
//     formContainer: {
//         padding: 32,
//         maxWidth: 400,
//         margin: 'auto',
//         backgroundColor: '#fff',
//         boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
//         borderRadius: 8,
//     },
//     formField: {
//         marginBottom: '3px !important',
//         width: '100%',
//     },
//     submitButton: {
//         marginTop: 16,
//         width: '100%',
//         backgroundColor: '#4b9ef1 !important',
//         color: '#fff !important',
//     },
// }));

// const Signin = () => {
//     const classes = useStyles();
//     const [username, setUsername] = useState("");
//     const [password, setPassword] = useState("");
//     const [message, setMessage] = useState("");
//     const { updateUser } = useContext(UserContext);
//     const navigate = useNavigate();

//     const handleSignin = async (e) => {
//         e.preventDefault();
//         try {
//             const response = await fetch(`${backendUrl}/signin`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: "include", // ✅ So cookie is sent
//                 body: JSON.stringify({ username, password }),
//             });
//             const data = await response.json();

//             if (!response.ok) {
//                 setMessage(data.message || "Signin failed.");
//             } else {
//                 updateUser(data.user); // ✅ sets localStorage
//                 navigate("/dashboard");
//             }
//         } catch (error) {
//             setMessage("Error during signin: " + error.message);
//         }
//     };

//     return (
//         <Paper className={classes.formContainer}>
//             <Typography variant="h5" align="center" gutterBottom>Sign In</Typography>
//             <form onSubmit={handleSignin}>
//                 <TextField label="Username" variant="outlined" className={classes.formField} value={username} onChange={(e) => setUsername(e.target.value)} required />
//                 <TextField label="Password" variant="outlined" type="password" className={classes.formField} value={password} onChange={(e) => setPassword(e.target.value)} required />
//                 <Button type="submit" variant="contained" className={classes.submitButton}>Sign In</Button>
//             </form>
//             {message && (
//                 <Typography variant="body2" align="center" style={{ marginTop: 16, fontSize: '0.85rem' }}>
//                     {message}
//                 </Typography>
//             )}
//         </Paper>
//     );
// };

// export default Signin;





















// // components/signin.jsx
// import React, { useState, useContext } from 'react';
// import { UserContext } from './userContext';
// import { useNavigate, Link } from 'react-router-dom';
// import { backendUrl } from "./config";
// import { Paper, Typography, TextField, Button, Divider } from '@mui/material';
// import { makeStyles } from '@mui/styles';

// const useStyles = makeStyles(() => ({
//     formContainer: {
//         padding: 32,
//         maxWidth: 400,
//         margin: 'auto',
//         backgroundColor: '#fff',
//         boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
//         borderRadius: 8,
//     },
//     formField: {
//         marginBottom: '16px !important',
//         width: '100%',
//     },
//     submitButton: {
//         marginTop: 16,
//         width: '100%',
//         backgroundColor: '#4b9ef1 !important',
//         color: '#fff !important',
//     },
//     googleButton: {
//         marginTop: 16,
//         width: '100%',
//         backgroundColor: '#db4437 !important',
//         color: '#fff !important',
//     },
//     footer: {
//         marginTop: 16,
//         display: 'flex',
//         justifyContent: 'space-between',
//     },
// }));

// const Signin = () => {
//     const classes = useStyles();
//     const [username, setUsername] = useState("");
//     const [password, setPassword] = useState("");
//     const [message, setMessage] = useState("");
//     const { updateUser } = useContext(UserContext);
//     const navigate = useNavigate();

//     const handleSignin = async (e) => {
//         e.preventDefault();
//         try {
//             const response = await fetch(`${backendUrl}/signin`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: "include",
//                 body: JSON.stringify({ username, password }),
//             });
//             const data = await response.json();

//             if (!response.ok) {
//                 setMessage(data.message || "Signin failed.");
//             } else {
//                 updateUser(data.user); // update user context/localStorage as needed
//                 navigate("/dashboard");
//             }
//         } catch (error) {
//             setMessage("Error during signin: " + error.message);
//         }
//     };

//     const handleGoogleSignin = () => {
//         // Redirect user to your backend's Google OAuth endpoint.
//         window.location.href = `${backendUrl}/auth/google`;
//     };

//     return (
//         <Paper className={classes.formContainer}>
//             <Typography variant="h5" align="center" gutterBottom>
//                 Sign In
//             </Typography>
//             <form onSubmit={handleSignin}>
//                 <TextField
//                     label="Username"
//                     variant="outlined"
//                     className={classes.formField}
//                     value={username}
//                     onChange={(e) => setUsername(e.target.value)}
//                     required
//                 />
//                 <TextField
//                     label="Password"
//                     variant="outlined"
//                     type="password"
//                     className={classes.formField}
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     required
//                 />
//                 <Button type="submit" variant="contained" className={classes.submitButton}>
//                     Sign In
//                 </Button>
//             </form>

//             {/* Divider to visually separate options */}
//             <Divider style={{ margin: "24px 0" }} />

//             {/* Google Sign In */}
//             <Button
//                 onClick={handleGoogleSignin}
//                 variant="contained"
//                 className={classes.googleButton}
//             >
//                 Sign In with Google
//             </Button>

//             <div className={classes.footer}>
//                 {/* Link to Forgot Password */}
//                 <Typography variant="body2">
//                     <Link to="/forgot-password" style={{ textDecoration: 'none' }}>
//                         Forgot Password?
//                     </Link>
//                 </Typography>
//             </div>

//             {message && (
//                 <Typography
//                     variant="body2"
//                     align="center"
//                     style={{ marginTop: 16, fontSize: '0.85rem' }}
//                 >
//                     {message}
//                 </Typography>
//             )}
//         </Paper>
//     );
// };

// export default Signin;















// import React, { useState, useContext } from 'react';
// import { backendUrl } from "./config";
// import { UserContext } from './userContext';
// import { useNavigate, Link } from 'react-router-dom';
// import { Paper, Typography, TextField, Button, Divider } from '@mui/material';
// import { makeStyles } from '@mui/styles';

// const useStyles = makeStyles(() => ({
//     formContainer: {
//         padding: 32,
//         maxWidth: 400,
//         margin: 'auto',
//         backgroundColor: '#fff',
//         boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
//         borderRadius: 8,
//     },
//     formField: {
//         marginBottom: '16px !important',
//         width: '100%',
//     },
//     submitButton: {
//         marginTop: 16,
//         width: '100%',
//         backgroundColor: '#4b9ef1 !important',
//         color: '#fff !important',
//     },
//     googleButton: {
//         marginTop: 16,
//         width: '100%',
//         backgroundColor: '#db4437 !important',
//         color: '#fff !important',
//     },
//     footer: {
//         marginTop: 16,
//         display: 'flex',
//         justifyContent: 'space-between',
//     },
// }));

// const Signin = () => {
//     const classes = useStyles();
//     const [username, setUsername] = useState("");
//     const [password, setPassword] = useState("");
//     const [message, setMessage] = useState("");
//     const { updateUser } = useContext(UserContext);
//     const navigate = useNavigate();

//     const handleSignin = async (e) => {
//         e.preventDefault();
//         try {
//             // 1) Sign in via POST to same-origin
//             const response = await fetch(`${backendUrl}/signin`, {
//                 method: 'POST',
//                 credentials: 'include',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ username, password }),
//             });
//             const data = await response.json();

//             if (!response.ok) {
//                 setMessage(data.message || 'Signin failed.');
//                 return;
//             }

//             // 2) Fetch dashboard to establish session
//             const userId = data.user.id || data.user._id;
//             await fetch(`${backendUrl}/dashboard/${userId}`, { credentials: 'include' });

//             // 3) Update context and navigate
//             updateUser(data.user);
//             navigate('/dashboard');
//         } catch (error) {
//             setMessage('Error during signin: ' + error.message);
//         }
//     };

//     const handleGoogleSignin = () => {
//         // Redirect to same-origin OAuth endpoint
//         window.location.href = `${backendUrl}/auth/google`;
//     };

//     return (
//         <Paper className={classes.formContainer}>
//             <Typography variant="h5" align="center" gutterBottom>
//                 Sign In
//             </Typography>
//             <form onSubmit={handleSignin}>
//                 <TextField
//                     label="Username"
//                     variant="outlined"
//                     className={classes.formField}
//                     value={username}
//                     onChange={(e) => setUsername(e.target.value)}
//                     required
//                 />
//                 <TextField
//                     label="Password"
//                     variant="outlined"
//                     type="password"
//                     className={classes.formField}
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     required
//                 />
//                 <Button type="submit" variant="contained" className={classes.submitButton}>
//                     Sign In
//                 </Button>
//             </form>

//             <Divider style={{ margin: '24px 0' }} />

//             <Button
//                 onClick={handleGoogleSignin}
//                 variant="contained"
//                 className={classes.googleButton}
//             >
//                 Sign In with Google
//             </Button>

//             <div className={classes.footer}>
//                 <Typography variant="body2">
//                     <Link to="/forgot-password" style={{ textDecoration: 'none' }}>
//                         Forgot Password?
//                     </Link>
//                 </Typography>
//             </div>

//             {message && (
//                 <Typography
//                     variant="body2"
//                     align="center"
//                     style={{ marginTop: 16, fontSize: '0.85rem' }}
//                 >
//                     {message}
//                 </Typography>
//             )}
//         </Paper>
//     );
// };

// export default Signin;





// // first update after restoration of web
// import React, { useState, useContext } from "react";
// import { backendUrl } from "./config";
// import { UserContext } from "./userContext";
// import { useNavigate, Link } from "react-router-dom";
// import { Paper, Typography, TextField, Button, Divider } from "@mui/material";
// import { makeStyles } from "@mui/styles";

// const useStyles = makeStyles(() => ({
//   formContainer: {
//     padding: 32,
//     maxWidth: 400,
//     margin: "auto",
//     backgroundColor: "#fff",
//     boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
//     borderRadius: 8,
//   },
//   formField: {
//     marginBottom: "16px !important",
//     width: "100%",
//   },
//   submitButton: {
//     marginTop: 16,
//     width: "100%",
//     backgroundColor: "#4b9ef1 !important",
//     color: "#fff !important",
//   },
//   googleButton: {
//     marginTop: 16,
//     width: "100%",
//     backgroundColor: "#db4437 !important",
//     color: "#fff !important",
//   },
//   footer: {
//     marginTop: 16,
//     display: "flex",
//     justifyContent: "space-between",
//   },
// }));

// const Signin = () => {
//   const classes = useStyles();
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [message, setMessage] = useState("");
//   const { updateUser } = useContext(UserContext);
//   const navigate = useNavigate();

//   const handleSignin = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(`${backendUrl}/signin`, {
//         method: "POST",
//         credentials: "include",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ username, password }),
//       });
//       const data = await response.json();

//       if (!response.ok) {
//         setMessage(data.message || "Signin failed.");
//         return;
//       }

//       // Optional extra fetch if needed to establish session
//       const userId = data.user.id || data.user._id;
//       await fetch(`${backendUrl}/dashboard/${userId}`, {
//         credentials: "include",
//       });

//       updateUser(data.user);
//       navigate("/dashboard");
//     } catch (error) {
//       setMessage("Error during signin: " + error.message);
//     }
//   };

//   const handleGoogleSignin = () => {
//     window.location.href = `${backendUrl}/auth/google`;
//   };

//   return (
//     <Paper className={classes.formContainer}>
//       <Typography variant="h5" align="center" gutterBottom>
//         Sign In
//       </Typography>
//       <form onSubmit={handleSignin}>
//         <TextField
//           label="Username"
//           variant="outlined"
//           className={classes.formField}
//           value={username}
//           onChange={(e) => setUsername(e.target.value)}
//           required
//         />
//         <TextField
//           label="Password"
//           variant="outlined"
//           type="password"
//           className={classes.formField}
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//         />
//         <Button type="submit" variant="contained" className={classes.submitButton}>
//           Sign In
//         </Button>
//       </form>

//       <Divider style={{ margin: "24px 0" }} />

//       <Button
//         onClick={handleGoogleSignin}
//         variant="contained"
//         className={classes.googleButton}
//       >
//         Sign In with Google
//       </Button>

//       <div className={classes.footer}>
//         <Typography variant="body2">
//           <Link to="/forgot-password" style={{ textDecoration: "none" }}>
//             Forgot Password?
//           </Link>
//         </Typography>
//       </div>

//       {message && (
//         <Typography variant="body2" align="center" style={{ marginTop: 16 }}>
//           {message}
//         </Typography>
//       )}
//     </Paper>
//   );
// };

// export default Signin;









// // src/components/Signin.jsx
// import React, { useState, useContext } from "react";
// import { backendUrl } from "./config";
// import { UserContext } from "./userContext";
// import { useNavigate, Link } from "react-router-dom";
// import { Paper, Typography, TextField, Button, Divider } from "@mui/material";
// import { makeStyles } from "@mui/styles";

// const useStyles = makeStyles(() => ({
//   formContainer: {
//     padding: 32,
//     maxWidth: 400,
//     margin: "auto",
//     backgroundColor: "#fff",
//     boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
//     borderRadius: 8,
//   },
//   formField: {
//     marginBottom: "16px !important",
//     width: "100%",
//   },
//   submitButton: {
//     marginTop: 16,
//     width: "100%",
//     backgroundColor: "#4b9ef1 !important",
//     color: "#fff !important",
//   },
//   googleButton: {
//     marginTop: 16,
//     width: "100%",
//     backgroundColor: "#db4437 !important",
//     color: "#fff !important",
//   },
//   footer: {
//     marginTop: 16,
//     display: "flex",
//     justifyContent: "space-between",
//   },
// }));

// const Signin = () => {
//   const classes = useStyles();
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [message, setMessage] = useState("");
//   const { updateUser } = useContext(UserContext);
//   const navigate = useNavigate();

//   const handleSignin = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(`${backendUrl}/signin`, {
//         method: "POST",
//         credentials: "include",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ username, password }),
//       });
//       const data = await response.json();

//       if (!response.ok) {
//         setMessage(data.message || "Signin failed.");
//         return;
//       }

//       // Optional extra fetch if needed to establish session
//       const userId = data.user.id || data.user._id;
//       await fetch(`${backendUrl}/dashboard/${userId}`, {
//         credentials: "include",
//       });

//       updateUser(data.user);
//       navigate("/dashboard");
//     } catch (error) {
//       setMessage("Error during signin: " + error.message);
//     }
//   };

//   const handleGoogleSignin = () => {
//     // CHANGE: redirect the browser to the backend’s /auth/google endpoint
//     window.location.href = `${backendUrl}/auth/google`;
//   };

//   return (
//     <Paper className={classes.formContainer}>
//       <Typography variant="h5" align="center" gutterBottom>
//         Sign In
//       </Typography>
//       <form onSubmit={handleSignin}>
//         <TextField
//           label="Username"
//           variant="outlined"
//           className={classes.formField}
//           value={username}
//           onChange={(e) => setUsername(e.target.value)}
//           required
//         />
//         <TextField
//           label="Password"
//           variant="outlined"
//           type="password"
//           className={classes.formField}
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//         />
//         <Button type="submit" variant="contained" className={classes.submitButton}>
//           Sign In
//         </Button>
//       </form>

//       <Divider style={{ margin: "24px 0" }} />

// {/*       <Button
//         onClick={handleGoogleSignin}
//         variant="contained"
//         className={classes.googleButton}
//       >
//         Sign In with Google
//       </Button> */}

//       <div className={classes.footer}>
//         <Typography variant="body2">
//           <Link to="/forgot-password" style={{ textDecoration: "none" }}>
//             Forgot Password?
//           </Link>
//         </Typography>
//       </div>

//       {message && (
//         <Typography variant="body2" align="center" style={{ marginTop: 16 }}>
//           {message}
//         </Typography>
//       )}
//     </Paper>
//   );
// };

// export default Signin;














// src/components/Signin.jsx
import React, { useState, useContext } from "react";
import { backendUrl } from "./config";
import { UserContext } from "./userContext";
import { useNavigate, Link } from "react-router-dom";
import { Paper, Typography, TextField, Button, Divider } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  formContainer: {
    padding: 32,
    maxWidth: 400,
    margin: "auto",
    backgroundColor: "#fff",
    boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
    borderRadius: 8,
  },
  formField: {
    marginBottom: "16px !important",
    width: "100%",
  },
  submitButton: {
    marginTop: 16,
    width: "100%",
    backgroundColor: "#4b9ef1 !important",
    color: "#fff !important",
  },
  googleButton: {
    marginTop: 16,
    width: "100%",
    backgroundColor: "#db4437 !important",
    color: "#fff !important",
  },
  footer: {
    marginTop: 16,
    display: "flex",
    justifyContent: "space-between",
  },
}));

const Signin = () => {
  const classes = useStyles();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { updateUser } = useContext(UserContext);
  const navigate = useNavigate();

  const handleSignin = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setMessage("");

    try {
      const response = await fetch(`${backendUrl}/signin`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json", "Cache-Control": "no-store" },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        setMessage(data.message || "Signin failed.");
        setLoading(false);
        return;
      }

      // Update context if user object returned (nice-to-have, not required)
      if (data?.user) {
        try { updateUser(data.user); } catch {}
      }

      // Tell the app "auth changed" (other tabs/listeners react too)
      try { localStorage.setItem("auth:changed", String(Date.now())); } catch {}

      // Hard navigation ensures UI cannot remain on /signin due to any stale state
      window.location.replace("/dashboard");
      // NOTE: we intentionally do not call navigate() here — replace() is safer under load

    } catch (error) {
      setMessage("Error during signin: " + (error?.message || "Unknown error"));
      setLoading(false);
    }
  };

  const handleGoogleSignin = () => {
    window.location.href = `${backendUrl}/auth/google`;
  };

  return (
    <Paper className={classes.formContainer}>
      <Typography variant="h5" align="center" gutterBottom>
        Sign In
      </Typography>
      <form onSubmit={handleSignin}>
        <TextField
          label="Username"
          variant="outlined"
          className={classes.formField}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          autoComplete="username"
        />
        <TextField
          label="Password"
          variant="outlined"
          type="password"
          className={classes.formField}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
        />
        <Button
          type="submit"
          variant="contained"
          className={classes.submitButton}
          disabled={loading}
        >
          {loading ? "Signing in…" : "Sign In"}
        </Button>
      </form>

      <Divider style={{ margin: "24px 0" }} />

      {/* If/when you re-enable Google OAuth:
      <Button
        onClick={handleGoogleSignin}
        variant="contained"
        className={classes.googleButton}
        disabled={loading}
      >
        Sign In with Google
      </Button> */}

      <div className={classes.footer}>
        <Typography variant="body2">
          <Link to="/forgot-password" style={{ textDecoration: "none" }}>
            Forgot Password?
          </Link>
        </Typography>
      </div>

      {message && (
        <Typography variant="body2" align="center" style={{ marginTop: 16, color: "#b00020" }}>
          {message}
        </Typography>
      )}
    </Paper>
  );
};

export default Signin;

